import { Grid } from '@mui/material';

import { BasePage } from 'main/components/_common/BasePage';
import { Notification } from './Notification';
import { Summary } from './Summary';
import { IMAGE_FOLDER } from 'main/utils/constants';

export const TopPage = () => {
    return (
        <BasePage>
            <Grid container direction="column" spacing={2} overflow="auto">
                <Grid item>
                    <img
                        src={`${IMAGE_FOLDER}/top.jpg`}
                        style={{ maxHeight: 600, width: '100%', objectFit: 'scale-down' }}
                        alt="players"
                    />
                </Grid>
                <Grid item>
                    <Notification />
                </Grid>
                <Grid item>
                    <Summary />
                </Grid>
            </Grid>
        </BasePage>
    )
}
